import React, { createContext, useState } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import { ReactPlugin } from '@microsoft/applicationinsights-react-js';

interface Props {
    children: React.ReactNode;
    config: { connectionString: string };
}

const AppInsightsContext = createContext<undefined | ApplicationInsights>(undefined);

export const AppInsightsProvider = ({ children, config }: Props) => {
    const [applicationInsights, setApplicationInsights] = useState<ApplicationInsights | undefined>(undefined);

    const { connectionString } = config;

    if (!applicationInsights && Boolean(connectionString)) {
        const reactPlugin = new ReactPlugin();

        const appInsights = new ApplicationInsights({
            config: {
                connectionString,
                disableFetchTracking: false,
                enableAutoRouteTracking: true,
                extensions: [reactPlugin],
            },
        });

        appInsights.loadAppInsights();

        setApplicationInsights(appInsights);
    }

    return <AppInsightsContext.Provider value={applicationInsights}>{children}</AppInsightsContext.Provider>;
};
